module.exports = __webpack_public_path__ + "img/XPM.70dd3627.svg";